import React, { useEffect, useState } from 'react';
import Loader from './Loader';
import { useAppContext } from '@/context/AppContext/AppContext';
import { initUser } from '@/stores/user';
import { initializeFeatureFlags } from '@/services/featureFlag';

/** This component is used to initialize the user
 * and feature flags outside of content lab */
export default function UserInitializer({ children }) {
  const { adminAppStore } = useAppContext();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    initUser(adminAppStore)
      .then(user => user)
      .catch(err => {
        console.error(err);
        return {};
      })
      .then(user => {
        initializeFeatureFlags(user);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [adminAppStore]);

  return loading ? (
    <div className="flex h-full w-full items-center justify-center">
      <Loader size="small" />
    </div>
  ) : (
    children
  );
}
